import requestOptions from './RequestOptions'
import UsuariosMapper from '../models/Seguridades_Mapper'
import GeneralMapper from '../models/General_Mapper'
import urlServices from "../../environments/API"
const urlSeguridades = urlServices.seguridad
const urlConfiguracion = urlServices.configuracion
const seguridadExt = urlServices.seguridadExt

const usuariosServiceold = async (page, perPage) => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.options('GET', token, '')
    const filter = '1/usuarios?codigoEmpresa=' + global.EMP_CODE + '&filtroTipoUsuario=TODOS&estado='
    const pagination = '&page=' + page + '&perPage=' + perPage + '&tipoFiltro=codigoUsuario_nombreUsuario&valorFiltro='
    const resp = await fetch(urlSeguridades + global.GET_USUARIOS + filter + pagination, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      const usuarios = data.data.rows
      /*const usuariosConRoles = await Promise.all(usuarios.map(async (usuario) => {
        const respRoles = await fetch(urlSeguridades + global.GET_ROLES_USUARIOS + usuario.secuenciaUsuario, options)
        const dataRoles = await respRoles.json()
        const roles = dataRoles.roles ? dataRoles.roles.map(role => role.nombreRol) : []
        return { ...usuario, roles }
      }))*/
      response = await UsuariosMapper.userMapper(usuarios, data.data.totalRows)
    } else {
      response = await GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const usuariosService = async (page, perPage, tipoUsuario, search) => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('GET', token, '')
    //const filter = '?codigoEmpresa=' + global.EMP_CODE + '&filtroTipoUsuario=TODOS&estado='

    let parameters = '?page=' + page + '&perPage=' + perPage + '&tipoUsuario=' + tipoUsuario;
    if (search !== undefined && search !== null && search.trim() !== '') {
      parameters += '&nombreBusqueda=' + encodeURIComponent(search);
    }

    const resp = await fetch(urlConfiguracion + global.GET_USUARIOS2 + parameters, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      const usuarios = data.data.rows
      response = await UsuariosMapper.userMapper(usuarios, data.data.totalRows)
    } else {
      response = await GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const usuariosLinkService = async (page, perPage, userType) => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('GET', token, '')
    //const filter = '?codigoEmpresa=' + global.EMP_CODE + '&filtroTipoUsuario=TODOS&estado='
    const pagination = '?page=' + page + '&perPage=' + perPage
    const resp = await fetch(urlConfiguracion + global.GET_USUARIOS2 + pagination + '&tipoUsuario=' + userType, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      const usuarios = data.data.rows
      response = await UsuariosMapper.userMapper(usuarios, data.data.length)
    } else {
      response = await GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const usuariosLinkServiceOld = async (page, perPage) => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.options('GET', token, '')
    const filter = '1/usuarios?codigoEmpresa=' + global.EMP_CODE + '&filtroTipoUsuario=TODOS&estado='
    const pagination = '&page=' + page + '&perPage=' + perPage + '&tipoFiltro=codigoUsuario_nombreUsuario&valorFiltro='
    const resp = await fetch(urlSeguridades + global.GET_USUARIOS + filter + pagination, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = await UsuariosMapper.userMapper(data.data.rows, data.data.totalRows)
    } else {
      response = await GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const usuariosByIdService = async (usuarioId) => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.options('GET', token, '')
    const resp = await fetch(urlSeguridades + global.GET_ROLES_USUARIOS + usuarioId, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = await UsuariosMapper.userByIdMapper(data.data)
    } else {
      response = await GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const rolesService = async (page, perPage, search = "") => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('GET', token, '')
    //let filter = '?codigoEmpresa=' + global.EMP_CODE + '&esActivo=T&codigoAplicacion=' + global.APP_CODE + '&tipoFiltro=nombreRol'
    //if (search !== "") {
    //  filter += '&nombreBusqueda=' + search;
    // }
    const pagination = '?page=' + page + '&perPage=' + perPage + '&codigoRol=' + search
    const resp = await fetch(seguridadExt + '/seguridad/rol/consultar_roles' + pagination, options)
    //const resp = await fetch("https://analitica.phantomx.com.ec/analitica/v1/portal_bi/seguridad/rol/consultar_roles?page=1&perPage=5", options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = UsuariosMapper.rolesMapper(data.data)
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const getRolesService = async (page, perPage, search = "") => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('GET', token, '')
    let filter = '?codigoEmpresa=' + global.EMP_CODE + '&esActivo=T&codigoAplicacion=' + global.APP_CODE + '&tipoFiltro=nombreRol'
    if (search !== "") {
      filter += '&nombreBusqueda=' + search;
    }
    const pagination = '&page=' + page + '&perPage=' + perPage + '&valorFiltro='
    //const resp = await fetch(urlConfiguracion + global.GET_ROLES + filter + pagination, options)
    const resp = await fetch("https://api.phantomx.com.ec/seguridad/v1/aplicaciones/6/opciones_menu", options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = UsuariosMapper.rolesMapper(data.data)
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const saveEditRolesServices = async (dataToSave) => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('POST', token, dataToSave)
    const resp = await fetch(seguridadExt + "/seguridad/rol/crear_rol", options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = GeneralMapper.responseMapper(data)
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const rolesPhantomService = async (page, perPage, search = "") => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('GET', token, '')
    //let filter = '?codigoEmpresa=' + global.EMP_CODE + '&esActivo=T&codigoAplicacion=' + global.APP_CODE + '&tipoFiltro=nombreRol'
    //if (search !== "") {
    //  filter += '&nombreBusqueda=' + search;
    // }
    const pagination = '?page=' + page + '&perPage=' + perPage + '&codigoRol=' + search
    //const resp = await fetch(seguridadExt + '/seguridad/rol/consultar_roles' + pagination, options)
    const resp = await fetch("https://api.phantomx.com.ec/seguridad/v1/roles?codigoAplicacion=6&codigoEmpresa=1&esActivo=T&page=1&perPage=4", options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = UsuariosMapper.rolesBIMapper(data.data)
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const rolesByUserService = async (page, perPage, valorFiltro) => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('GET', token, '')
    let filter = '?page=' + page + '&perPage=' + page + '&estado=S&tipoFiltro=codigoUsuario&valorFiltro=' + valorFiltro + '&tipoUsuario=I&registoUnico=S'

    const resp = await fetch("https://analitica.phantomx.com.ec/analitica/v1/portal_bi/dashboard/consultar_usuarios" + filter, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = UsuariosMapper.rolesMapperXUsuario(data.data)
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const rolesByUserExtService = async (page, perPage, valorFiltro) => {
  let response
  try {
    const token = `Bearer ${localStorage.getItem('token')}`
    const options = requestOptions.optionsConfig('GET', token, '')
    let filter = '?page=' + page + '&perPage=' + page + '&estado=S&tipoFiltro=codigoUsuario&valorFiltro=' + valorFiltro + '&tipoUsuario=E&registoUnico=S'

    const resp = await fetch("https://analitica.phantomx.com.ec/analitica/v1/portal_bi/dashboard/consultar_usuarios" + filter, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = UsuariosMapper.rolesMapperXUsuario(data.data)
    } else {
      response = GeneralMapper.responseMapper(data)
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }
  return response
}

const UserServices = {
  usuariosService,
  rolesService,
  usuariosByIdService,
  usuariosLinkService,
  usuariosServiceold,
  usuariosLinkServiceOld,
  getRolesService,
  saveEditRolesServices,
  rolesPhantomService,
  rolesByUserService,
  rolesByUserExtService
}

export default UserServices
